"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserCard = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ui = require("../../../ui");
var _Status = require("./Status");
var _BirthDate = require("./BirthDate");
var _utils = require("../../../../utils");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Card = (0, _styledComponents.default)(_ui.Card)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-shadow: none;\n  background-color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.secondaryShade;
});
var CardList = (0, _styledComponents.default)(_ui.Col)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-top: 20px;\n"])));
var UserInfo = (0, _styledComponents.default)(_ui.H4)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-bottom: 20px;\n  padding: 8px 0;\n"])));
var UserCard = (0, _styledComponents.default)(function (_ref2) {
  var className = _ref2.className,
    name = _ref2.name,
    surname = _ref2.surname,
    birthDate = _ref2.birthDate,
    confirmed = _ref2.confirmed,
    children = _ref2.children;
  return /*#__PURE__*/_react.default.createElement(Card, {
    className: className
  }, /*#__PURE__*/_react.default.createElement(_ui.CardBody, null, /*#__PURE__*/_react.default.createElement(_ui.Row, {
    className: "flex-xl-column"
  }, /*#__PURE__*/_react.default.createElement(_ui.Col, {
    className: "text-center",
    xs: 12
  }, name && birthDate && /*#__PURE__*/_react.default.createElement(UserInfo, null, name, " ", surname, ", ", /*#__PURE__*/_react.default.createElement(_BirthDate.BirthDate, {
    date: birthDate
  })), /*#__PURE__*/_react.default.createElement(_Status.Status, {
    confirmed: confirmed
  })), !confirmed && /*#__PURE__*/_react.default.createElement(CardList, {
    xs: 12
  }, children))));
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n"])), _utils.mediaQuery.greaterThan('md')(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    width: 305px;\n  "]))), _utils.mediaQuery.lessThan('xl')(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    margin-bottom: 30px;\n  "]))), _utils.mediaQuery.greaterThan('xl')(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    margin-bottom: 0;\n  "]))));
exports.UserCard = UserCard;